<template>
    <div class="page noScroll">
        <div class="page-content noScroll">
            <div class="uploadPicture scroll-container">
                <!-- content -->
                <div class="uploadPicture-content">
                    <div class="uploadPicture-info">
                        <div class="uploadPicture-textarea">
                            <textarea v-model="content" placeholder="请附上16字以上配文，晒出您与皇家游轮的精彩时刻！" minlength="16"></textarea>
                        </div>
                        <!-- upload Pic -->
                        <div class="uploadPicture-uploadPic">
                            <div class="uploadPicture-cameraUpload" v-if="uploadPics.length === 0">
                                <div>
                                    <img src="../../assets/cameraPic.jpg" alt="上传美图">
                                </div>
                                <span>上传游记美图</span>
                                <div class="uploadPicture-inputUpload js-inputUpload">
                                    <input type="file" multiple="multiple" @change="handleUpload($event)" ref="input">
                                </div>
                            </div>
                            <div class="uploadPicture-uploadOpe" v-else>
                                <div class="uploadPicture-hadUploadOpe" v-for="(item, index) in uploadPics" :key="index">
                                    <div class="uploadPicture-hadUploadPic">
                                        <img :src="item.url" alt="已上传美图">
                                    </div>
                                    <div class="uploadPicture-deletePic" @click="deletePic(index)">
                                        <img src="../../assets/closeIcon.png" alt="删除图片按钮">
                                    </div>
                                </div>
                                <div class="uploadPicture-addUploadOpe" v-if="uploadPics.length < 4">
                                    <img src="../../assets/addImgIcon.png" alt="上传美图">
                                    <div class="uploadPicture-inputUpload js-inputUpload">
                                        <input type="file" multiple="multiple" @change="handleUpload($event)" ref="input">
                                    </div>
                                </div>
                            </div>

                            <div class="uploadPicture-caution">注：最多上传4张图片</div>
                        </div>
                    </div>
                    <div class="uploadPicture-choice">
                        <div class="uploadPicture-choiceIcon">
                            <img src="../../assets/imgIcon.png" alt="图片Icon">
                        </div>
                        <div class="uploadPicture-choiceInfo js-openModel" @click="showFilter">
                            <div class="uploadPicture-choiceTags" v-if="selectedList.length === 0">
                                <span style="float:right">选择图片类型和出航日期</span>
                            </div>
                            <div class="uploadPicture-choiceTags" v-else>
                                <span class="uploadPicture-tagItem" v-for="(item, index) in selectedList" :key="index">{{item.text}}</span>
                            </div>
                            <span class="uploadPicture-choiceArrow" aria-hidden="true"></span>
                        </div>
                    </div>
                    <div class="uploadPicture-author">
                        <img src="https://resource.rcclchina.com.cn/logo/MB/logoAvatarCircleBlueLarge.png" alt="logo">
                        <a href="javascript: void(0)" class="external js-changeNick" @click="toUpdate"><span>{{nickName}}</span></a>
                    </div>
                </div>

                <div class="uploadPicture-agree js-agreeBtn" v-bind:class="{active: agreeActive}" @click="changeAgree">
                    <div><span class="uploadPicture-checkmark" aria-hidden="true"></span></div>
                    <p>我理解并接受<span class="js-userRules"><a href="javascript:void(0)" @click="showProtocol">《秀美图协议》</a></span></p>
                </div>
                <div class="uploadPicture-uploadBtn">
                    <button class="js-uploadBtn" @click="createItem">上 传</button>
                </div>
            </div>
        </div>
        <UploadFilter :isShow="isShowFilter"
                      :filterData="filterData"
                      :initData="selectedList"
                      :shipCode="myShipCode"
                      @on-cancel="cancelFilter"
                      @on-confirm="submitInfo"></UploadFilter>
        <Protocol :isShow="isShowProtocol"
                  @on-close="closeProtocol"></Protocol>
    </div>
</template>

<script>
	import api from '@/api'
	import Protocol from '@/components/Review/Protocol.vue'
	import UploadFilter from '@/components/Review/UploadFilter.vue'
	export default {
		name: 'UploadPicture',
		components: {
			Protocol,
			UploadFilter
		},
		data () {
			return {
				userToken: '',
				isShowProtocol: false,
				isShowFilter: false,
				content: '',
				uploadPics: [],
				selectedList: [],
				myShipCode: '',
				picId: '',
				nickName: '',
				filterData: {},
				agreeActive: true
			}
		},
		beforeMount () {
            this.$store.commit('SET_PAGE_TITLE', '秀美图')
			this.showPage()
		},
        beforeRouteLeave (to, from, next) {
            if (to.path.indexOf('/Rccl.Review/ReviewPicture/NickName') > -1) {
                console.log(from)
                this.$store.dispatch('SET_UPLOAD_CONTENT', {
                    content: this.content,
                    uploadPics: this.uploadPics,
                    selectedList: this.selectedList,
                    myShipCode: this.myShipCode
                })
            } else {
                this.$store.dispatch('SET_UPLOAD_CONTENT', {}) // 清空存储
            }
            next()
        },
		methods: {
			async showPage () {
				this.$loading.show()
				await this.initPage()
				this.$loading.hide()
			},
			async initPage () {
				this.userToken = this.$store.state.user.userToken
				if (!this.userToken || this.userToken.length == 0) {
					this.$router.push(`/Orchard.Rccl.Users/Login/Login?returnUrl=${encodeURIComponent(window.location.pathname)}`)
					return
				}

				this.picId = this.$route.query.picId

				// 加载选择项
				this.filterData = await this.getReviewPicsFilter()

                //获取本地存储
                const uploadContent = this.$store.state.page.uploadContent

				// 加载详情
				if (this.picId === undefined) {
					this.nickName = await this.getNickName(this.userToken)
                    if (!this.nickName) {
                        this.$router.push('/Rccl.Review/ReviewPicture/NickName')
                    } else {
                        this.content = uploadContent.content || ''
                        this.uploadPics = uploadContent.uploadPics || []
                        this.selectedList = uploadContent.selectedList || []
                        this.myShipCode = uploadContent.myShipCode || ''
                    }
					return
				}
				const detail = await this.getReviewDetail(this.picId, this.userToken)
				this.content = uploadContent.content || detail.content
				this.uploadPics = uploadContent.uploadPics || detail.images
				this.selectedList = uploadContent.selectedList || this.getSelectedList(detail)
				this.myShipCode = uploadContent.myShipCode || detail.shipCode
				this.nickName = detail.nickname ? detail.nickname : await this.getNickName(this.userToken)

			},
			async getReviewDetail (reviewPicId, userName) {
				const {success, data, errMsg} = await api.review.getReviewDetail({reviewPicId, userName})
				if (!success) {
					console.log(errMsg)
					return null
				} else {
					return data
				}
			},
			getSelectedList (detail) {
				let result = []
				if (detail.tags.length > 0) {
					detail.tags.map(item => {
						result.push({
							type: 0,
							text: item
						})
					})
				}
				if (detail.shipName) {
					result.push({
						type: 1,
						text: detail.shipName
					})
				}
				if (detail.sailDate) {
					result.push({
						type: 2,
						text: detail.sailDate
					})
				}
				return result
			},
			async getReviewPicsFilter (requestData) {
				const {success, data, errMsg} = await api.review.getReviewPicsFilter(requestData)
				if (!success) {
					this.$alert.show(errMsg)
				} else {
					return data
				}
			},

			async getNickName (userToken) {
				const {success, data, errMsg} = await api.review.getNickName(userToken)
				if (!success) {
					console.log(errMsg)
				} else {
					return data
				}
			},
			showProtocol () {
				this.isShowProtocol = true
			},
			closeProtocol () {
				this.isShowProtocol = false
			},
			showFilter () {
				this.isShowFilter = true
			},
			cancelFilter () {
				this.isShowFilter = false
			},
			submitInfo (obj) {
				this.selectedList = obj.list
				this.myShipCode = obj.shipCode
				this.isShowFilter = false
			},
			async handleUpload (e) {
				if (this.uploadPics.length >= 4) {
					this.$alert.show('最多上传4张图片')
					return false
				}

				// 已经上传和待上传的超过4张提示
				let files = e.target.files
                if (this.uploadPics.length + files.length > 4) {
                    this.$alert.show('最多上传4张图片')
                    return false
                }

                // 上传
                for (let i = 0, len = files.length; i < len; i++) {
                    if (this.uploadPics.length >= 4) break
                    await this.singleUpload(files[i])
                }
			},
			async singleUpload (file) {
				if (!/(image\/jpg|image\/png|image\/jpeg|image\/gif)/.test(file.type)) {
					this.$alert.show('图片格式错误')
					return false
				}
				this.$loading.show()
				let data = await this.upload(file)
				this.$loading.hide()
				this.uploadPics = [...this.uploadPics, ...data]
			},
			async upload (file) {
				const res = await this.uploadImgToBase64(file)
				const base64 = res.result.replace(/.*;base64,/, '')
				const {success, data, errMsg} = await api.review.uploadPic({
					userName: this.userToken,
					images: [{
						base64: base64,
						fileName: file.name
					}]
				})
				if (!success) {
					console.log(errMsg)
					return null
				} else {
					return data
				}
			},
			uploadImgToBase64 (file) {
				return new Promise((resolve, reject) => {
					let reader = new FileReader()
					reader.readAsDataURL(file)
					reader.addEventListener('load', () => {
						resolve(reader)
					})
					reader.addEventListener('error', () => {
						reject()
					})
				})
			},
			deletePic (index) {
				this.uploadPics.splice(index, 1)
			},
			changeAgree () {
				this.agreeActive = !this.agreeActive
			},
			async createItem () {
				if (this.content === '') {
					this.$alert.show('请输入标题内容')
					return false
				}
				if (this.content.length < 16) {
					this.$alert.show('配文字数必须大于16个')
					return false
				}
				if (this.uploadPics.length === 0) {
					this.$alert.show('请上传游记美图')
					return false
				}
				if (this.selectedList.length === 0) {
					this.$alert.show('请选择图片类型')
					return false
				}
				if (!this.selectedList.find(item => item.type === 0)) {
					this.$alert.show('请选择图片类型')
					return false
				}
				if (!this.selectedList.find(item => item.type === 1)) {
					this.$alert.show('请选择游轮')
					return false
				}
				if (!this.selectedList.find(item => item.type === 2)) {
					this.$alert.show('请选择出航日期')
					return false
				}
				if (this.nickName === '') {
					this.$alert.show('请输入昵称')
					return false
				}
				if (!this.agreeActive) {
					this.$alert.show('请勾选协议规则')
					return false
				}
				let shipCode = this.myShipCode
				let sailDate = this.selectedList.find(item => item.type === 2)
				let tags = []
				this.selectedList.map(item => {
					if (item.type === 0) {
						tags.push(item.text)
					}
				})
				let imageUrls = [];
				this.uploadPics.forEach(item => {
					imageUrls.push(item.url)
				})
				console.log({
					userName: this.userToken,
					content: this.content,
					imageUrls,
					sailDate: sailDate.text,
					shipCode,
					tags,
					id: this.picId
				})

				// 提交信息
				this.$loading.show()
				await this.subInfo({
					userName: this.userToken,
					content: this.content,
					imageUrls,
					sailDate: sailDate.text,
					shipCode,
					tags,
					id: this.picId
				})
				this.$loading.hide()
			},
			async subInfo (requestData) {
				const {success, errMsg} = await api.review.createPic(requestData)
				if (!success) {
					this.$alert.show(errMsg)
					return null
				} else {
					this.$router.push('/Rccl.Review/ReviewPicture/OwnPicture')
				}
			},
			toUpdate () {
				let param = {}
				if (this.picId === undefined) {
					param = {
						name: 'NickName',
						params: {
							nickName: this.nickName
						}
					}
				} else {
					param = {
						name: 'NickName',
						params: {
							nickName: this.nickName
						},
						query: {
							picId: this.picId
						}
					}
				}
				this.$router.replace(param)
			}
		}
	}
</script>

<style scoped>
    .page{
        display: block;
        padding-top: 50px;
    }
    .page-content {
        background-color: #f0f0f0;
    }
    .uploadPicture {
        padding-bottom: 88px;
        background-color: #f0f0f0;
        overflow: auto;
    }
    .uploadPicture-content {
        padding:15px 12px 0 12px;
        background-color:#fff;
    }
    .uploadPicture-info {
        margin-bottom:51px;
    }
    .uploadPicture-textarea {
        margin-left:7px;
    }
    .uploadPicture-textarea textarea{
        width:100%;
        height:70px;
        font-size:13px;
        color:#000;
        border:none;
    }
    .uploadPicture-textarea textarea::-webkit-input-placeholder,
    .uploadPicture-textarea textarea::-moz-placeholder,
    .uploadPicture-textarea textarea:-moz-placeholder{
        font-size:13px;
        color:#c9c9c9;
    }
    .uploadPicture-uploadPic {
        margin-top:21px;
    }
    .uploadPicture-cameraUpload {
        position:relative;
    }
    .uploadPicture-cameraUpload>div{
        width:82px;
        height:82px;
        display:inline-block;
        vertical-align:middle;
    }
    .uploadPicture-cameraUpload>div img{
        width:100%;
    }
    .uploadPicture-cameraUpload span{
        color:#c9c9c9;
        font-size:13px;
        margin-left:19px;
        vertical-align:middle;
    }
    .uploadPicture-uploadOpe {
        overflow:hidden;
    }
    .uploadPicture-hadUploadOpe {
        position: relative;
        float: left;
        margin-right: 6px;
        margin-bottom:8px;
    }
    .uploadPicture-hadUploadOpe:nth-child(4n+4) {
        margin-right:0;
    }
    .uploadPicture-hadUploadPic {
        width: 82px;
        height: 82px;
        overflow:hidden;
    }
    .uploadPicture-hadUploadPic > img {
        position:relative;
        left:50%;
        top:50%;
        transform:translate(-50%,-50%);
        -webkit-transform:translate(-50%,-50%);
        -moz-transform:translate(-50%,-50%);
        -o-transform:translate(-50%,-50%);
        -ms-transform:translate(-50%,-50%);
        max-width:100%;
        max-height:100%;
    }
    .uploadPicture-deletePic {
        width:24px;
        height:24px;
        position:absolute;
        top:0;
        right:0;
        padding:4px;
    }
    .uploadPicture-deletePic>img{
        width:100%;
    }
    .uploadPicture-addUploadOpe {
        width: 83px;
        height: 83px;
        float: left;
        position:relative;
    }
    .uploadPicture-addUploadOpe>img{
        width:100%;
    }
    .uploadPicture-choice {
        clear:both;
        padding: 15px 0 17px 0;
        display: flex;
        flex-direction: row;
        -webkit-flex-direction: row;
        justify-content: space-between;
        -webkit-justify-content: space-between;
        align-items: center;
        -webkit-align-items: center;
        border-top:1px solid #e0e0e0;
    }
    .uploadPicture-choiceIcon img{
        width:24px;
        height:17px;
    }
    .uploadPicture-choiceInfo {
    }
    .uploadPicture-choiceInfo .uploadPicture-choiceTags {
        display:inline-block;
        width:252px;
        vertical-align:middle;
        text-align:right;
    }
    .uploadPicture-choiceInfo .uploadPicture-choiceTags span{
        font-size:13px;
        color:#c9c9c9;
        display:inline-block;
        margin-right: 4px;
    }
    .uploadPicture-choiceInfo  .uploadPicture-tagItem {
        margin-right: 6px;
        color:#666;
        font-size:12px;
        position: relative;
        padding: 2px 7px;
        background-color: #efefef;
        border-radius:6px;
    }
    .uploadPicture-choiceArrow {
        display:inline-block;
        width:8px;
        height:8px;
        border-top:1px solid #f7b611;
        border-right:1px solid #f7b611;
        transform:rotate(45deg);
        -webkit-transform:rotate(45deg);
        vertical-align:middle;
        margin-left:4px;
    }
    .uploadPicture-author {
        padding: 10px 0;
        font-size: 0;
        border-top: 1px solid #e0e0e0;
    }
    .uploadPicture-author>img {
        width:27px;
        height:27px;
        vertical-align:middle;
    }
    .uploadPicture-author a{
        display:inline-block;
    }
    .uploadPicture-author span {
        color:#666;
        font-size:13px;
        vertical-align:middle;
        margin-left:6px;
    }
    .uploadPicture-agree {
        margin-top:17px;
        margin-left:12px;
    }
    .uploadPicture-agree > div {
        border: 1px solid #c9c9c9;
        border-radius: 4px;
        display: inline-block;
        width:15px;
        height:15px;
        vertical-align:middle;
    }
    .uploadPicture-agree .uploadPicture-checkmark{
        display:none;
        width:5px;
        height:9px;
        border:solid #0073a8;
        border-width:0 2px 2px 0;
        transform:rotate(45deg);
        -webkit-transform:rotate(45deg);
        margin:1px auto 0;
    }
    .uploadPicture-agree.active>div{
        border:1px solid #0073a8;
        border-radius:4px;
    }
    .uploadPicture-agree.active .uploadPicture-checkmark {
        display:block;
    }
    .uploadPicture-agree p {
        font-size:12px;
        color:#333;
        display:inline-block;
        margin:0 0 0 5px;
        vertical-align:middle;
    }
    .uploadPicture-agree span {
        color:#0073a8;
    }
    .uploadPicture-uploadBtn {
        padding:0 12px;
        width:100%;
        margin-top:38px;
    }
    .uploadPicture-uploadBtn button{
        width: 100%;
        height: 36px;
        line-height: 36px;
        text-align: center;
        background-color: #f7b611;
        font-size: 12.5px;
        color: #fff;
        border:none;
    }
    .uploadPicture-inputUpload {
        width:100% !important;
        height:82px;
        position:absolute;
        left:0;
        top:0;
    }
    .uploadPicture-inputUpload input{
        width:100%;
        height:100%;
        border:1px solid red;
        opacity:0;
        filter:alpha(opacity=0);
    }

    .uploadPicture-caution {
        font-size: 12px;
        color: #c9c9c9;
        margin-top: 6px;
    }
</style>
